// Navbar.jsx
import React, { useState } from 'react';
import { 
  LightModeOutlined, 
  DarkModeOutlined, 
  Menu as MenuIcon, 
  Search, 
  ArrowDropDownOutlined,
  Logout
} from '@mui/icons-material';
import FlexBetween from './FlexBetween';
import { useDispatch, useSelector } from 'react-redux';
import { setMode, setLogout } from 'state';
import avatarImg from 'assets/avatar.png';
import { 
  AppBar, 
  Button, 
  IconButton, 
  InputBase, 
  Menu, 
  MenuItem, 
  Toolbar, 
  Typography, 
  useTheme,
  Divider 
} from '@mui/material';
import { Box } from '@mui/system';

const Navbar = ({
  isSidebarOpen,
  setIsSidebarOpen
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  
  // Récupérer l'utilisateur depuis Redux
  const user = useSelector((state) => state.global.user);
  
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  
  // Fonction pour gérer la déconnexion
  const handleLogout = () => {
    handleClose(); // Fermer le menu d'abord
    // Dispatch l'action de déconnexion Redux
    dispatch(setLogout());
    // Redirection vers la page de login
    window.location.href = '/login';
  };

  // Si pas d'utilisateur dans Redux, charger depuis localStorage
  const displayUser = user || JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <AppBar
      sx={{
        position: 'static',
        background: "none",
        boxShadow: 'none'
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        {/* Partie gauche avec menu et recherche */}
        <FlexBetween>
          <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
            <MenuIcon />
          </IconButton>
          {/* <FlexBetween
            backgroundColor={theme.palette.background.alt}
            borderRadius='9px'
            gap="3rem"
            p="0.1rem 1.5rem"
          >
            <InputBase placeholder='Search...' />
            <IconButton>
              <Search />
            </IconButton>
          </FlexBetween> */}
        </FlexBetween>


        {/* Partie droite avec thème et profil */}
        <FlexBetween gap='1.5rem'>
          <IconButton onClick={() => dispatch(setMode())}>
            {theme.palette.mode === 'dark' ? (
              <DarkModeOutlined sx={{ fontSize: "25px" }} />
            ) : (
              <LightModeOutlined sx={{ fontSize: "25px" }} />
            )}
          </IconButton>

          <FlexBetween>
            <Button 
              onClick={handleClick} 
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                textTransform: 'none',
                gap: '1rem'
              }}
            >
              <Box
                component="img"
                alt="profile"
                src={avatarImg}
                height="32px"
                width="32px"
                borderRadius="50%"
                sx={{ objectFit: "cover" }}
              />
              <Box textAlign="left">
                <Typography
                  fontWeight="bold"
                  fontSize="0.85rem"
                  sx={{ color: theme.palette.secondary[100] }}
                >
                  {displayUser.username || displayUser.name || 'Utilisateur'}
                </Typography>
                {displayUser.role && (
                  <Typography
                    fontSize="0.75rem"
                    sx={{ color: theme.palette.secondary[200] }}
                  >
                    {displayUser.role}
                  </Typography>
                )}
              </Box>
              <ArrowDropDownOutlined
                sx={{ color: theme.palette.secondary[300], fontSize: "25px" }}
              />
            </Button>

            {/* Menu déroulant du profil */}
            <Menu 
              anchorEl={anchorEl} 
              open={isOpen} 
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              PaperProps={{
                sx: {
                  mt: 1,
                  minWidth: 200,
                  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)'
                }
              }}
            >
              {/* Section informations utilisateur */}
              <Box sx={{ px: 2, py: 1.5 }}>
                <Typography variant="subtitle1" fontWeight="bold">
                  {displayUser.username || displayUser.name || 'Utilisateur'}
                </Typography>
                {displayUser.email && (
                  <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
                    {displayUser.email}
                  </Typography>
                )}
                {displayUser.module_actif && (
                  <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
                    Module: {displayUser.module_actif}
                  </Typography>
                )}
              </Box>
              
              <Divider />
              
              {/* Option Déconnexion avec icône */}
              <MenuItem 
                onClick={handleLogout}
                sx={{
                  py: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  color: theme.palette.error.main
                }}
              >
                <Logout fontSize="small" />
                <Typography>Déconnexion</Typography>
              </MenuItem>
            </Menu>
          </FlexBetween>
        </FlexBetween>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;